import React from 'react'

function ClampTextLines({ children, lines = 1000000, ...props }) {
  const styles = {
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }

  return (
    <div {...props} style={styles}>
      {children}
    </div>
  )
}

export default ClampTextLines
